
// firebase promesse a vuex ....vuex promesse al componente che richiama una sua azione.

export default class FirebaseOperations {
  // eslint-disable-next-line no-useless-constructor
  constructor(firebaseApp) {
    this.firebaseApp = firebaseApp
    this.db = firebaseApp.database()
    this.storage = firebaseApp.storage()
    this.auth = firebaseApp.auth()
  }
  queryDb(pointer) {
    // non in uso perchè non riesco a gestire gli eventi real time. 
    // Retrieve new posts as they are added to our database
    return new Promise((resolve, reject) => {
      this.db.ref(pointer).on('value', function (snapshot, prevChildKey) {
        resolve(snapshot.val())
      })
    })

    /* PER USARE PROMESSA FARE COSI.
       this.databaseOps.queryDb(pointer).then(data => {
      commit('setTableRowsData', data)
    })
      .catch(err => {
        console.log(err)
      })
    */
  }
}
